module.exports = __webpack_public_path__ + "media/images/favicon/favicon-32x32-222f30471bab8e9fe3326e28ecb1d923.png";